import React from 'react';
import { useSelector } from 'react-redux';

import { DocumentViewer } from './PdfViewer.style';
import { PdfView } from './PdfView';
import { getDealPdfUrl } from '../../store';
import type { DealSummaryPdfView } from '../../hook/useDealSummaryPdfRenderedTelemetry';

export const PdfViewer: React.FC<{ view: DealSummaryPdfView }> = ({ view }) => {
    const dealPdfUrl = useSelector(getDealPdfUrl);

    return (
        <DocumentViewer data-testid="view-quote-document-viewer">
            <PdfView pdfUrl={dealPdfUrl} view={view} />
        </DocumentViewer>
    );
};
